import React from 'react';
import Lottie from 'react-lottie-player'
import loot from '../../img/jjj.json';
import { NavLink } from 'react-router-dom';


const Error = () => {


  return (
    
    <>

  <section>
   <div className='container'>
    <div className='row'>
     <div className='col-lg-6 col-md-6 col-sm-12 m-auto'>

     <div className='row'>
      <div className='col-lg-12 col-sm-12'>
       <h2 style={{color:'#585858', textAlign:'center', paddingTop:'50px'}}>Error : 404!!</h2>

       <p className='mt-4' style={{color:'#585858',textAlign:'center'}}>Looks like the page you are looking for is either<br/> Inactive or you are not authorized to access it</p>


       <div style={{display:'flex', justifyContent:'center'}}>  
        
       <Lottie
       loop
       animationData={loot}   play  style={{ width: '60%', height: '100%' }}
     /> 

       </div>
  

       <NavLink to='/' style={{textDecoration:'none'}}>
       <div style={{display:'flex', justifyContent:'center'}}>
       <button type='btn' 
        style={{backgroundColor:'#546EF5', color:'#fff', border:'none', padding:'10px 20px', borderRadius:'8px'}}>Back to Home </button>
        </div> 
        </NavLink>

      </div>
     </div>
     
     </div>
    </div>
   </div>
  </section>

    </>
  )
}

export default Error